import { UnderConstructionComponent } from '@components/shared/under-construction/under-construction.component';
import { Component } from '@angular/core';

@Component({
  selector: 'app-cleaning-type',
  imports: [UnderConstructionComponent],
  templateUrl: './cleaning-type.component.html'
})
export class CleaningTypeComponent {}
